import type { SiteContent } from "../siteData";

type CallToActionProps = {
  cta: SiteContent["cta"];
};

export function CallToAction({ cta }: CallToActionProps) {
  return (
    <section className="section section--charcoal section--ctaDock" aria-label="Listen links">
      <div className="container ctaFloatingShell">
        <a className="button button--pill" href={cta.href} target="_blank" rel="noopener noreferrer">
          {cta.label}
        </a>
      </div>
    </section>
  );
}
